import { SortDescriptor } from 'app/_shared/interfaces/Category'

export enum ComponentEnum {
  TextArea = 'TEXT_AREA',
  TextWithImage = 'TEXT_WITH_IMAGE',
  BannerImage = 'BANNER_IMAGE',
  ProductList = 'PRODUCTS_LIST',
  Title = 'TITLE',
  RedirectTiles = 'REDIRECT_TILES'
}

export interface ImageContent {
  url?: string
  id: string
}

export interface BannerContent {
  img?: ImageContent
  fullWidth?: boolean
  redirect?: string
}

export interface TitleContent {
  title: string
  font?: string
  fontSize?: string
}

export interface TextWithImageContent {
  img: ImageContent
  text: string
  imagePosition: string
}

export interface TextAreaContent {
  text: string
}

export interface ProductListContent {
  productsPerRow: number
  categories: number[]
  listAllProducts?: boolean
  showFilters: boolean
  sortingOption?: SortDescriptor | null
  productsPerPage: number
  productsToShow?: number
  leadCategory?: number
}

export interface RedirectTileItem {
  id: string
  type: 'category' | 'page'
  url: string
  title?: string
}

export interface RedirectTile {
  id: string
  redirectOnClick?: boolean
  visible?: boolean
  redirectUrl?: string
  categoriesOrPagesRedirect?: boolean
  image: {
    url: string
    id?: string
  }
  item?: RedirectTileItem
}

export interface RedirectTilesContent {
  title?: string
  font?: string
  fontSize?: number
  tilesInRow: number
  tilesAlignment: 'left' | 'center' | 'right'
  items: RedirectTile[]
}

export interface Section<T = any> {
  id: string
  component: ComponentEnum
  content: T
  label: string
}

export interface Page {
  title: string
  url: string
  text: string
  id: string
  hasPassword?: boolean
  allowedAccess?: boolean
  sections: Section[]
}

export interface Item {
  title: string
  url: string
  type: string
  text: string
  id: string
  sections: Section[]
}

export interface Menu {
  label: string
  customUrl?: string
  item?: Item
  children?: Menu[]
  visible?: boolean
  footerVisible?: boolean
}

export interface Config {
  settings?: Settings
  menu?: Menu[]
  pages?: Page[]
}

export interface SocialIcons {
  name: string
  url: string
}

export interface Settings {
  websiteFont?: string
  primaryColor?: string
  secondaryColor?: string
  pagesBackgroundColor?: string
  alertText?: string
  alertBackgroundColor?: string
  logoPosition?: string
  favicon?: string
  buttonShape?: 'round' | 'square' | 'pill'
  logo?: string
  footerContent?: string
  copyrightText?: string
  socialIcons?: SocialIcons[]
  productsPerPage?: number
  productsPerRow?: number
  no_index_site?: number
  sortBy?: SortDescriptor
  headerBackgroundColor?: string
  menuBackgroundColor?: string
  menuTextColor?: string
  bodyBackgroundColor?: string
  bodyTextColor?: string
  buttonColor?: string
  buttonTextColor?: string
  buttonHoverColor?: string
  buttonHoverTextColor?: string
  footerBackgroundColor?: string
  footerTextColor?: string
}
